export enum FulfillmentStatus {
  Pending = 'pending',
  Queued = 'queued',
  StartPreparing = 'start-preparing',
  Preparing = 'preparing',
  ReadyForServing = 'ready-for-serving',
  Served = 'served',
  Canceled = 'canceled',
}

export enum FulfillmentType {
  PreOrder = 'pre-order',
  WalkIn = 'walk-in',
  OrderToSeat = 'order-to-seat',
}

export const fulfillmentStatusOptions = [
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.Pending, val: FulfillmentStatus.Pending },
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.Queued, val: FulfillmentStatus.Queued },
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.StartPreparing, val: FulfillmentStatus.StartPreparing },
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.Preparing, val: FulfillmentStatus.Preparing },
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.ReadyForServing, val: FulfillmentStatus.ReadyForServing },
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.Served, val: FulfillmentStatus.Served },
  { text: 'orders.fulfillment_statuses.' + FulfillmentStatus.Canceled, val: FulfillmentStatus.Canceled },
];

export const fulfillmentTypeOptions = [
  { text: 'orders.fulfillment_types.' + FulfillmentType.PreOrder, val: FulfillmentType.PreOrder },
  { text: 'orders.fulfillment_types.' + FulfillmentType.WalkIn, val: FulfillmentType.WalkIn },
  { text: 'orders.fulfillment_types.' + FulfillmentType.OrderToSeat, val: FulfillmentType.OrderToSeat },
];

// Lines in these statuses may already be prepared or handed out — refund dialogs warn about them.
export const fulfillmentRefundWarningStatuses = [
  FulfillmentStatus.Preparing,
  FulfillmentStatus.ReadyForServing,
  FulfillmentStatus.Served,
];
